<template>
  <a-card>
    <a-form layout="inline" :form="form">
      <a-form-item>
        <a-select placeholder="--请选择事业部--" v-decorator="['bussdepId']" style="width:200px" allowClear>
          <a-select-option :key="businss.id" v-for="businss in businssDept">{{ businss.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-select placeholder="--请选择业务--" v-decorator="['bussdepType']" style="width:200px" allowClear>
          <a-select-option :key="bussdep.key" v-for="bussdep in bussdepType">{{ bussdep.value }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-select placeholder="--状态--" v-decorator="['status']" style="width:200px">
          <a-select-option :value="1">正常</a-select-option>
          <a-select-option :value="2">暂停</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="handleSearch">搜索</a-button>
      </a-form-item>
      <a-form-item>
        <a-button @click="handleReset">重置</a-button>
      </a-form-item>
    </a-form>
    <br />
    <div>
      <a-button type="primary" @click="handleAdd">新增配置</a-button>
    </div>
    <br />
    <a-table :dataSource="tableData" rowKey="id" :pagination="pagination" @change="handlePageChange" :loading="loading">
      <a-table-column title="事业部" data-index="bussdepId">
        <template slot-scope="bussdepId">{{ businssDeptFilter(bussdepId) }}</template>
      </a-table-column>
      <a-table-column title="所属业务" data-index="bussdepType">
        <template slot-scope="_bussdepType">{{ bussdepTypeFilter(_bussdepType) }}</template>
      </a-table-column>
      <a-table-column title="应用名称" data-index="name"> </a-table-column>
      <a-table-column title="回调URL" data-index="callbackurl"></a-table-column>
      <a-table-column title="状态" data-index="status">
        <template slot-scope="status">
          {{ status | statusFilter }}
        </template>
      </a-table-column>
      <a-table-column title="操作">
        <template slot-scope="item">
          <a-button type="link" @click="handleEdit(item)">编辑</a-button>
        </template>
      </a-table-column>
    </a-table>
    <ModifyModal ref="modifyModal" @success="handleSearch" />
  </a-card>
</template>

<script>
import tableMixin from '@/components/mixins/table'
import { bussdepType } from '@/config/public'
import { mapGetters } from 'vuex'
import ModifyModal from './ModifyModal'
import { depList } from '@/api/common'
import { blacklistconfList } from '@/api/blackListSync'
export default {
  mixins: [tableMixin],
  components: { ModifyModal },
  data() {
    return {
      bussdepType: [],
      businssDept: []
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'blackListSync' })
  },
  mounted() {
    if (window.environment == 'bz') {
      this.bussdepType = bussdepType.filter(item => item.value === '投教')
    } else {
      this.bussdepType = bussdepType
    }
    this.getBussdep()
    this.handleSearch()
  },
  methods: {
    getBussdep() {
      depList().then(res => {
        if (res.code == 1) {
          this.businssDept = res.result
        }
      })
    },
    async getTableData() {
      const params = this.form.getFieldsValue()
      try {
        const { code, message, result } = await blacklistconfList(params)
        if (code === 1) {
          this.tableData = result
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        console.error(error)
        this.$message.error(error.message)
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.getTableData()
    },
    handleReset() {
      this.form.resetFields()
    },
    handleAdd() {
      this.$refs.modifyModal.open({ isEdit: false })
    },
    handleEdit(item) {
      this.$refs.modifyModal.open({ formData: item, isEdit: true })
    },
    bussdepTypeFilter(value) {
      const bussdep = this.bussdepType.find(bussdep => bussdep.key == value)
      return (bussdep && bussdep.value) || '/'
    },
    businssDeptFilter(value) {
      const business = this.businssDept.find(bussiness => bussiness.id === value)
      return (business && business.name) || '/'
    }
  },
  filters: {
    statusFilter(value) {
      return value === 1 ? '正常' : '暂停'
    }
  }
}
</script>

<style></style>
